import { Page } from '@/core/architecture'

import { DmRoomsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * DmRooms Page
 * Implemented as a practical sample.
 */
export const DmRooms: Page = () => {
  const { state, actions } = useViewModel()

  return <DmRoomsTemplate state={state} {...actions} />
}
